import { create } from 'zustand';

export type LogLevel = 'info' | 'success' | 'warning' | 'error' | 'progress' | 'undo' | 'redo';

export interface LogEntry {
  id: string;
  timestamp: Date;
  level: LogLevel;
  message: string;
  details?: string;
}

interface LogState {
  logs: LogEntry[];
  addLog: (level: LogLevel, message: string, details?: string) => void;
  clearLogs: () => void;
}

export const useLogStore = create<LogState>((set) => ({
  logs: [],
  addLog: (level, message, details) => set((state) => ({
    logs: [
      ...state.logs,
      {
        id: Math.random().toString(36).substring(2, 9),
        timestamp: new Date(),
        level,
        message,
        details,
      },
    ],
  })),
  clearLogs: () => set({ logs: [] }),
}));
